import { SignatureRemote } from "./SignatureRemote";

export default SignatureRemote;